import React from 'react';
import { useLocation } from 'react-router-dom';
import { IframeIntegration } from 'integrations';

// const blackList: string[] = [];

export const useRestoreScrollPosition = (): void => {
    const location = useLocation();

    React.useEffect(() => {
        // Uncomment to prevent scrollToTop on exact routes
        // if (blackList.some((route) => location.pathname.includes(route))) {
        //     return;
        // }

        IframeIntegration.scrollToTop();
    }, [location.pathname]);
};
